import { css } from 'emotion'

export const TaskSizesMainStyles = css`
  > header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
`
